// Cap Table screen (Screen 2) — PSD §10.2. 1 primary column + context rail.
//
// Stage 6e /polish: previously every block in the primary column and rail
// was a .card. Drop the wrapper around the empty-state and the placeholder
// Instrument Library card — both are placeholders/readouts, not data
// surfaces, so the border was visual noise. LiquidationTermsRail stays a
// card (it holds real form fields). The primary column now has a deliberate
// open→contained rhythm instead of identical card stacks.

import { useEffect } from 'react';
import { Layers, Package } from 'lucide-react';
import { useStore, useSettings } from '../store/selectors';
import { CapTableEditor } from '../components/captable/CapTableEditor';
import { LiquidationTermsRail } from '../components/captable/LiquidationTermsRail';
import { FullyDilutedReadout } from '../components/captable/FullyDilutedReadout';
import { SnapshotSelector } from '../components/captable/SnapshotSelector';
import { EmptyState } from '../components/common/EmptyState';

export function CapTableScreen() {
  const settings = useSettings();
  const entity = settings.activeEntityName ?? 'New Entity';
  const draft = useStore((s) => s.draftCapTable);
  const loadCapTables = useStore((s) => s.loadCapTablesForEntity);
  const emptyCap = useStore((s) => s.commitSnapshot);

  useEffect(() => {
    void loadCapTables(entity);
  }, [entity, loadCapTables]);

  return (
    <div>
      <h1 className="screen-title">Cap Table</h1>
      <div className="captable-layout">
        <div className="stack-5">
          {draft ? (
            <CapTableEditor entity={entity} />
          ) : (
            <EmptyState
              icon={<Layers size={32} strokeWidth={1.5} />}
              message="This cap table is empty."
              hint="The waterfall needs at least one class to allocate value. Start from common stock, or import from Carta, Pulley, or Ledgy."
              action={
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    const cap = {
                      id: `cap_${Date.now()}`,
                      version: 1,
                      asOfDate: new Date().toISOString().slice(0, 10),
                      entityName: entity,
                      instruments: [],
                      convertibles: [],
                      currency: 'USD',
                    };
                    emptyCap(entity, cap);
                  }}
                >
                  Start Cap Table
                </button>
              }
            />
          )}
          <FullyDilutedReadout />
        </div>
        <aside className="stack-5">
          <LiquidationTermsRail entity={entity} />
          <SnapshotSelector entity={entity} />
          <div className="panel-open">
            <div className="card-title">Instrument Library</div>
            <EmptyState
              icon={<Package size={28} strokeWidth={1.5} />}
              message="Reusable instrument library ships in Phase 2."
            />
          </div>
        </aside>
      </div>
    </div>
  );
}
